import Home from './pages/Home';
import AOS from 'aos';
import { useEffect } from 'react';
import Contact from './pages/Contact';
import Layout from './common/Layout';
import Services from './pages/Services';
import Showcase from './pages/Showcase';
import Team from './pages/Team';
import Training from './pages/Training';
import Gallery from './pages/Gallery';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Editorials from './pages/Editorials';

function App() {
    useEffect(() => {
        AOS.init();
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path='/training' element={<Training />} />
                    <Route path='/services' element={<Services />} />
                    <Route path='/editorials' element={<Editorials />} />
                    <Route path='/showcase' element={<Showcase />} />
                    <Route path='/team' element={<Team />} />
                    <Route path='/contact' element={<Contact />} />
                    <Route path=':section/gallery/:id' element={<Gallery />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
